var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoinfoverde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.51 20.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #72b7a4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.26,20.51C4.6,20.51,0,15.91,0,10.26S4.6,0,10.26,0s10.26,4.6,10.26,10.26-4.6,10.26-10.26,10.26ZM10.26.83C5.06.83.83,5.06.83,10.26s4.23,9.43,9.43,9.43,9.43-4.23,9.43-9.43S15.46.83,10.26.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.31,9.59l4.01-1.34c.32-.11.66-.03.91.19h0c.34.31.4.82.14,1.2l-3.48,5.06c-.19.28-.05.66.27.74h0c.12.03.25.02.36-.04l2.23-1.04c.07-.03.16,0,.18.07h0c.02.06,0,.12-.05.16l-2.41,1.7c-.65.46-1.52.47-2.18.02h0c-.86-.59-1.08-1.75-.51-2.61l2.01-3.05c.21-.31-.03-.73-.41-.71l-1.01.05c-.06,0-.13-.02-.17-.07h0c-.09-.11-.04-.28.09-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.57,6.3c-.6.75-1.56.98-2.13.52-.58-.46-.55-1.45.05-2.2.6-.75,1.56-.98,2.13-.52.58.46.55,1.45-.05,2.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoinfoverde);
export default __webpack_public_path__ + "static/media/icono info verde.735ad0f1d98cb7a248ba3b0f855284b2.svg";
export { ForwardRef as ReactComponent };